import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { image, SanityImage } from './image';
import { richText } from './richText';

export const SanityVideoTwoUpCard = z.object({
  _key: z.string(),
  eyebrow: z.string().optional().nullable(),
  title: z.string(),
  subtitle: z.string().optional().nullable(),
  thumbnailImage: SanityImage,
  mediaType: z.enum(['youtube', 'mux']),
  videoUrl: z.string().optional().nullable(),
  playbackId: z.string().optional().nullable(),
});
export type SanityVideoTwoUpCard = z.infer<typeof SanityVideoTwoUpCard>;

export const SanityVideoTwoUp = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('videoTwoUp'),
  _key: z.string(),
  theme: z.enum(['light', 'dark', 'charcoal', 'purple']),
  overline: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  description: SanityBasicText.optional().nullable(),
  videos: z.array(SanityVideoTwoUpCard).min(2).max(2),
});
export type SanityVideoTwoUp = z.infer<typeof SanityVideoTwoUp>;

export const videoTwoUp = groq`{
  "theme": select(theme == "dark" => "charcoal", coalesce(theme, "charcoal")),
  overline,
  title,
  description[] ${richText},
  videos[] {
    _key,
    eyebrow,
    title,
    subtitle,
    thumbnailImage ${image},
    "mediaType": coalesce(mediaType, "youtube"),
    videoUrl,
    "playbackId": muxVideo.asset->playbackId,
  },
}`;
